import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'components/atoms/Icon/';
import './Checkbox.scss';

const ns = 'checkbox';

const Checkbox = ({
  onClick,
  id,
  isSelected,
  inputType,
  ariaLabel,
  ...otherProps
}) => {
  return (
    <div
      className={ns}
      tabIndex={0}
      aria-label={ariaLabel}
      onKeyUp={e => {
        if (e.key === 'Enter') {
          onClick();
        }
      }}
    >
      <label htmlFor={id}>
        <input
          id={id}
          type={inputType}
          className={`${ns}--hidden`}
          checked={isSelected}
          onClick={onClick}
          onChange={() => {}}
          tabIndex={-1}
          {...otherProps}
        />
        <Icon type="check" className="rounded-circle" />
      </label>
    </div>
  );
};

Checkbox.propTypes = {
  id: PropTypes.string,
  inputType: PropTypes.string,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func,
  onKeyUp: PropTypes.func,
  ariaLabel: PropTypes.string
};

Checkbox.defaultProps = {
  inputType: 'checkbox',
  isSelected: false,
  onClick: () => {}
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/atoms/Checkbox/Checkbox.js